// extracted by mini-css-extract-plugin
module.exports = {"badge":"neJRnir4","BadgeIcon":"_2Iw4cJM9","BadgeMessage":"_2Jtle3il"};